@if (loading) {
<div class="loading-spinner-overlay">
  <div class="loading-spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
</div>
} @else {
<div class="padding full-height">
  <div class="flex-container-vertical-center">
    <h1 class="margin-sides-8" data-testid="base-order-order-type">{{ order.orderTypeID | enumLabel:'orderType':orderTypeName }}</h1>
    <span class="spacer"></span>
    <!-- Lien Result Document(s) -->
    @for (result of order.lien?.registrationResults ?? []; track result) {
    <div class="margin-sides-8">
      @if (!isDischarge()) {
      <lib-document-download [documentID]="$safeNavigationMigration(result.document?.id)" [documentName]="'common.labels.verificationStatement' | transloco">
      </lib-document-download>
      }
    </div>
    }
    <!-- Discharge Result Document(s) -->
    @if (isDischarge() && order.discharge?.document) {
    <div class="margin-sides-8">
      <span class="spacer"></span>
      <lib-document-download [documentID]="order.discharge!.document!.id"
        [documentName]="'common.labels.verificationStatement' | transloco"></lib-document-download>
    </div>
    }
    @if (isPpsaSearchOrder() && this.order.searchResult) {
    <lib-vinsights></lib-vinsights>
    }
    <!-- Search Result Document(s) -->
    @if (order.searchResult || uboTreeNode) {
    <lib-download-search-documents class="margin-sides-8" data-testid="base-order-search-results-button"
      [hideResultDocument]="uiConfiguration.businessReportDetailsConfiguration?.hideResultDocument ?? false"
      [hideRegHubDocument]="uiConfiguration.businessReportDetailsConfiguration?.hideRegHubDocument ?? false"
      [uboTreeNode]="uboTreeNode" 
      [showParsedResultsJson]="_showJSONParsedResults"
      [order]="order"></lib-download-search-documents>
    }
  </div>
  <mat-card [@slideDown]="showConsortiumHints() ? 'visible' : 'hidden'" class="card-margin"
    [ngClass]="{'red': hasRedHint(), 'yellow': !hasRedHint() }">
    <div class="flex-container">
      <span class="text flex-item-6"><mat-icon class="icon">warning</mat-icon>{{ (hasRedHint() ? 'orders.activityDetectedOutside' : 'orders.activityDetectedWithin') | transloco: { jurisdictions: getHintJurisdictions() } }}</span>
      <button matSuffix mat-raised-button class="flex-item margin-sides-15" [attr.aria-label]="'orders.actionWarningActivityLevel' | transloco"
        (click)="onOrderSearch()" data-testid="warn-activity-level-action-button">
        {{ 'orders.orderSearch' | transloco }}
      </button>
    </div>
  </mat-card>
  <div class="horizontal-flex-container">
    <!-- Order Type Card -->
    <mat-card class="flex-item card-margin">
      <mat-card-content>
        <div class="flex-container">
          <span class="flex-item-2">{{ 'orders.referenceNumber' | transloco }}</span>
          <span class="flex-item-2 flex-container-vertical-center" data-testid="base-order-reference-number-text">
            <b>{{ order.referenceNumber }}</b>
            <lib-copy-to-clipboard [value]="order.id" [tooltip]="'common.labels.copyOrderId' | transloco" style="margin-left: 5px;"></lib-copy-to-clipboard>
          </span>
        </div>
        <div class="flex-container">
          <span class="flex-item-2">{{ 'orders.country' | transloco }}</span>
          <span class="flex-item-2" data-testid="base-order-country-text">{{ order.country |
            fullCountryName }}</span>
        </div>
        <div class="flex-container">
          <span class="flex-item-2">{{ 'orders.jurisdiction' | transloco }}</span>
          <span class="flex-item-2" data-testid="base-order-jurisdiction-text">{{ order.displayJurisdiction }}</span>
        </div>
        @if (order.lien?.qcFormTypeID) {
        <div class="flex-container">
          <span class="flex-item-2">{{ 'orders.form' | transloco }}</span>
          <span class="flex-item-2" data-testid="base-order-qc-form-text">{{ order.lien!.qcFormTypeID
            }}</span>
        </div>
        }
        @if (uiConfiguration.hasUltimateBeneficialOwnershipReportDetails) {
        <div class="flex-container">
          <span class="flex-item-2">{{ 'common.labels.attestor' | transloco }}</span>
          <span class="flex-item-2" data-testid="base-order-jurisdiction-text">
            {{ utilities.getIndividualName(attestor, false) }}
          </span>
        </div>
        }
        @if (uiConfiguration.hasUltimateBeneficialOwnershipReportDetails) {
        <div class="flex-container">
          <span class="flex-item-2">{{ 'common.labels.attestorEmail' | transloco }}</span>
          <span class="flex-item-2" data-testid="base-order-attestor-email">{{ attestor?.contactDetails?.email }}</span>
        </div>
        }
        @if (uiConfiguration.hasUltimateBeneficialOwnershipReportDetails) {
        <div class="flex-container">
          <span class="flex-item-2">{{ 'common.labels.attestationTemplate' | transloco }}</span>
          <span class="flex-item-2" data-testid="base-order-attestation-template">{{ attestationTemplateName }}</span>
        </div>
        }
        @if (attestationRequestorDetailsVisible()) {
          <div class="flex-container">
            <span class="flex-item-2">{{ 'common.labels.corporationNameDisplayed' | transloco }}</span>
            <span class="flex-item-2" data-testid="attestor-first-name-text">{{ order.ultimateBeneficialOwnershipRequest?.displayedCorpName }}</span>
          </div>
        }
      </mat-card-content>
    </mat-card>
    <mat-card class="flex-item card-margin">
      <mat-card-content>
        <div class="flex-container-center">
          <span class="flex-item-2">{{ 'orders.status' | transloco }}</span>
          <span class="flex-item-2 flex-container-vertical-center">
            <lib-order-status [order]="order"></lib-order-status>
            <span data-testid="status-text"><b>{{ order.orderStatusTypeID | enumLabel:'orderStatusType' }}</b></span>
          </span>
        </div>
        <div class="flex-container">
          <span class="flex-item-2">{{ 'orders.requestedBy' | transloco }}</span>
          <span class="flex-item-2" data-testid="requested-by-text">{{ requestingUser }}</span>
        </div>
        @if (_hasMultipleUserGroups) {
        <div class="flex-container">
          <span class="flex-item-2">{{ 'orders.requestedFor' | transloco }}</span>
          <span class="flex-item-2" data-testid="requested-for-text">{{ requestingUserGroup }}</span>
        </div>
        }
        <div class="flex-container">
          <span class="flex-item-2">{{ 'orders.dateRequested' | transloco }}</span>
          <span class="flex-item-2" data-testid="requested-date-text">{{ order.dateRequested |
            localizedDate: 'yyyy-MM-dd'}}</span>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <!-- Search Criteria Card -->
  @if (isPpsaSearchOrder() || order.orderTypeID === "DebtorMultiSearch") {
  <mat-card class="card-margin">
    <mat-card-content>
      <lib-order-search-criteria></lib-order-search-criteria>
    </mat-card-content>
  </mat-card>
  }
  <!-- Multi search -->
  @if (isMultiSearchOrder()) {
  <mat-card class="card-margin">
    <h3>{{ 'common.labels.orders' | transloco }}</h3>
    <mat-card-content>
      <lib-multi-search-orders [orderUpdate$]="this.ordersHub.completedOrder$"></lib-multi-search-orders>
    </mat-card-content>
  </mat-card>
  }
  @if (uiConfiguration?.hasBusinessSearchCriteria) {
  <mat-card class="card-margin">
    <mat-card-content>
      <lib-order-business-search-criteria></lib-order-business-search-criteria>
    </mat-card-content>
  </mat-card>
  }
  @if (uiConfiguration?.hasBusinessReportCriteria) {
  <mat-card class="card-margin">
    <mat-card-content>
      <lib-order-business-report-criteria></lib-order-business-report-criteria>
    </mat-card-content>
  </mat-card>
  }
  @if (order.orderTypeID === 'KnowYourCustomer') {
  <mat-card class="card-margin kyc-details">
    <mat-card-content class="kyc-details">
      <lib-know-your-customer-details [order]="order"></lib-know-your-customer-details>
    </mat-card-content>
  </mat-card>
  }
  <!-- <mat-card class="card-margin" *ngIf="uiConfiguration?.hasUltimateBeneficialOwnershipResults">
  <mat-card-content>
    <lib-order-business-report-criteria></lib-order-business-report-criteria>
  </mat-card-content>
</mat-card> -->
  <!-- Existing Registration Details Card -->
  @if (uiConfiguration?.hasReferenceRegistrationInformation) {
  <mat-card class="card-margin">
    <h3>{{ 'common.labels.existingRegistrationDetails' | transloco }}</h3>
    <mat-card-content>
      <lib-existing-registration-details
        [uiConfiguration]="uiConfiguration!.referenceRegistrationInformationUIConfiguration!">
      </lib-existing-registration-details>
    </mat-card-content>
  </mat-card>
  }
  @if (uiConfiguration.hasRenewalDetails && order?.lien && isRenewal()) {
  <div class="horizontal-flex-container">
    <!-- Renewal Details Card -->
    <mat-card class="flex-item-4 card-margin">
      <h3>{{ 'orders.renewalDetails' | transloco }}</h3>
      <mat-card-content>
        @for (result of order.lien?.registrationResults ?? []; track result) {
        <div>
          @if (uiConfiguration?.amendmentConfiguration?.hasMultipleForms) {
          <h4 class="no-margin">
            {{ 'common.labels.typeResults' | transloco: { type: result.registryForm?.formFull ?? '' } }}
          </h4>
          }
          <lib-lien-results [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!" [results]="result">
          </lib-lien-results>
          <br />
        </div>
        }
        @if (uiConfiguration.hasRenewalDetails) {
        <lib-lien-details [uiConfiguration]="uiConfiguration.renewalDetailsConfiguration!">
        </lib-lien-details>
        }
      </mat-card-content>
    </mat-card>
    @if (showLifetime()) {
    <mat-card class="flex-item-2 card-margin">
      <mat-card-content>
        <lib-lien-lifetime></lib-lien-lifetime>
      </mat-card-content>
    </mat-card>
    }
  </div>
  }
  @if (uiConfiguration.amendmentConfiguration && order?.lien) {
  <div class="horizontal-flex-container">
    <!-- Renewal Details Card -->
    <mat-card class="flex-item-4 card-margin">
      <h3>{{ 'orders.amendmentDetails' | transloco }}</h3>
      <mat-card-content>
        @if ((order.lien?.registrationResults?.length ?? 0) > 0) {
        <div>
          @for (result of order.lien?.registrationResults ?? []; track result) {
          <div>
            @if (uiConfiguration?.amendmentConfiguration?.hasMultipleForms) {
            <h4 class="no-margin">
              {{ 'common.labels.typeResults' | transloco: { type: result.registryForm?.formFull ?? '' } }}
            </h4>
            }
            <lib-lien-results [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!" [results]="result">
            </lib-lien-results>
            <br />
          </div>
          }
        </div>
        }
        @if ((order.lien?.registrationResults?.length ?? 0) == 0) {
        <div>
          <lib-lien-results [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!">
          </lib-lien-results>
        </div>
        }
        <lib-lien-details [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!"></lib-lien-details>
      </mat-card-content>
    </mat-card>
    @if (showLifetime()) {
    <mat-card class="flex-item-2 card-margin">
      <mat-card-content>
        <lib-lien-lifetime></lib-lien-lifetime>
      </mat-card-content>
    </mat-card>
    }
  </div>
  }
  @if (uiConfiguration.hasDischargeDetails) {
  <div class="horizontal-flex-container">
    <!-- Discharge Details Card -->
    <mat-card class="flex-item-4 card-margin">
      <h3>{{ 'orders.dischargeDetails' | transloco }}</h3>
      <mat-card-content>
        <lib-discharge-details [uiConfiguration]="uiConfiguration.dischargeDetailsConfiguration!" [order]="order"
          class="flex-item"></lib-discharge-details>
      </mat-card-content>
    </mat-card>
    @if (showLifetime()) {
    <mat-card class="flex-item-2 card-margin">
      <mat-card-content>
        <lib-lien-lifetime></lib-lien-lifetime>
      </mat-card-content>
    </mat-card>
    }
  </div>
  }
  @if (!isDischarge() && !isRenewal() && !isAmendment()) {
  <div class="horizontal-flex-container">
    <!-- Lien Details Card -->
    @if (uiConfiguration.hasLienDetails && order?.lien) {
    <mat-card class="flex-item-4 card-margin">
      <h3>{{ 'common.labels.typeDetails' | transloco: { type: getOrderTypeName() } }}</h3>
      <mat-card-content>
        @for (result of order.lien?.registrationResults ?? []; track result) {
        <div>
          @if (result.registryForm) {
          <h4 class="no-margin"> {{ 'common.labels.typeResults' | transloco: { type: result.registryForm.formFull } }} </h4>
          }
          <lib-lien-results [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!" [results]="result">
          </lib-lien-results>
          <br />
        </div>
        }
        @if (uiConfiguration.hasLienDetails) {
        <lib-lien-details [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!">
        </lib-lien-details>
        }
      </mat-card-content>
    </mat-card>
    }
    @if (showLifetime() && !isRenewal() && !isAmendment()) {
    <mat-card class="flex-item-2 card-margin">
      <mat-card-content>
        <lib-lien-lifetime></lib-lien-lifetime>
      </mat-card-content>
    </mat-card>
    }
  </div>
  }
  <!-- Secured Parties Card -->
  @if (!isPpsaSearchOrder() && uiConfiguration?.hasSecuredParties) {
  <mat-card class="card-margin">
    <h3>{{ 'common.labels.securedParties' | transloco }}</h3>
    <mat-card-content data-testid="secured-parties-card">
      <lib-parties-list [order]="order" [title]="securedPartiesTitle | transloco" [observableParties$]="securedParties" [isEditable]="false"
        [uiConfiguration]="uiConfiguration!.securedPartiesConfiguration!" class="flex-item-no-padding">
      </lib-parties-list>
    </mat-card-content>
  </mat-card>
  }
  <!-- Assignors Card -->
  @if (!isPpsaSearchOrder() && uiConfiguration?.hasAssignors) {
  <mat-card class="card-margin">
    <h3>{{ 'common.labels.assignors' | transloco }}</h3>
    <mat-card-content data-testid="assignors-card">
      <lib-parties-list [order]="order" [title]="'common.labels.assignors' | transloco" [observableParties$]="assignors" [isEditable]="false"
        [uiConfiguration]="uiConfiguration!.assignorsConfiguration!" class="flex-item-no-padding">
      </lib-parties-list>
    </mat-card-content>
  </mat-card>
  }
  <!-- Assignees Card -->
  @if (!isPpsaSearchOrder() && uiConfiguration?.hasAssignees) {
  <mat-card class="card-margin">
    <h3>{{ 'common.labels.assignees' | transloco }}</h3>
    <mat-card-content data-testid="assignees-card">
      <lib-parties-list [order]="order" [title]="'common.labels.assignees' | transloco" [observableParties$]="assignees" [isEditable]="false"
        [uiConfiguration]="uiConfiguration!.assigneesConfiguration!" class="flex-item-no-padding">
      </lib-parties-list>
    </mat-card-content>
  </mat-card>
  }
  <!-- Debtors Card -->
  @if (!isPpsaSearchOrder() && uiConfiguration?.hasDebtors) {
  <mat-card class="card-margin">
    <h3>{{ debtorsTitle | transloco }}</h3>
    <mat-card-content data-testid="debtors-parties-card">
      <lib-parties-list [title]="debtorsTitle | transloco" [observableParties$]="debtors" [order]="order" [isEditable]="false"
        [uiConfiguration]="uiConfiguration!.debtorsConfiguration!" class="flex-item-no-padding">
      </lib-parties-list>
    </mat-card-content>
  </mat-card>
  }
  <!-- Dealers Card -->
  @if (uiConfiguration?.hasDealers) {
  <mat-card class="card-margin">
    <h3>{{ 'common.labels.dealers' | transloco }}</h3>
    <mat-card-content data-testid="dealers-parties-card">
      <lib-parties-list [order]="order" [title]="dealersTitle | transloco" [observableParties$]="dealers" [isEditable]="false"
        [uiConfiguration]="uiConfiguration!.dealersConfiguration!" class="flex-item-no-padding">
      </lib-parties-list>
    </mat-card-content>
  </mat-card>
  }
  <!-- Business Parties Card -->
  @if (uiConfiguration?.hasBusinessParties) {
  <mat-card class="card-margin">
    <h3>{{ 'common.labels.parties' | transloco }}</h3>
    <mat-card-content data-testid="business-parties-card">
      <lib-parties-list [order]="order" [title]="partiesTitle | transloco" [observableParties$]="businessParties"
        [isEditable]="false" [uiConfiguration]="uiConfiguration!.businessPartyConfiguration!"
        class="flex-item-no-padding">
      </lib-parties-list>
    </mat-card-content>
  </mat-card>
  }
  <!-- General Collateral Card -->
  @if (uiConfiguration!.collateralConfiguration?.hasGeneralCollateral) {
  <mat-card class="card-margin" data-testid="general-collateral-card">
    <h3>{{ 'common.labels.generalCollateral' | transloco }}</h3>
    <mat-card-content>
      <lib-general-collateral
        [uiConfiguration]="$safeNavigationMigration(uiConfiguration.collateralConfiguration?.generalCollateralConfiguration)">
      </lib-general-collateral>
    </mat-card-content>
  </mat-card>
  }
  <!-- Assets Card -->
  @if (uiConfiguration!.collateralConfiguration?.hasAssets && (order.assets?.length ?? 0) > 0) {
  <mat-card class="card-margin" data-testid="general-collateral-card">
    <h3>{{ 'common.labels.assets' | transloco }}</h3>
    <mat-card-content>
      <app-asset-list [order]="order" [uiConfiguration]="uiConfiguration!.collateralConfiguration!.assetConfiguration!"
        class="flex-item">
      </app-asset-list>
    </mat-card-content>
  </mat-card>
  }
  <!-- Registering Agent Card -->
  @if (uiConfiguration?.hasRegisteringAgents) {
  <mat-card class="card-margin" data-testid="registering-agent-parties-card">
    <h3>{{ 'common.labels.registeringAgent' | transloco }}</h3>
    <mat-card-content>
      <lib-parties-list [order]="order" [title]="registeringAgentsTitle | transloco" [observableParties$]="registeringAgents" [isEditable]="false"
        [uiConfiguration]="uiConfiguration!.registeringAgentsConfiguration!" class="flex-item-no-padding">
      </lib-parties-list>
    </mat-card-content>
  </mat-card>
  }
  <!-- Business Search Criteria Card -->
  @if (uiConfiguration?.hasBusinessSearchCriteria) {
  <mat-card class="card-margin min-height-200" data-testid="business-search-results-card">
    <mat-card-content>
      @if (order.country === 'US') {
        <lib-us-business-search-results></lib-us-business-search-results>
      } @else {
        <lib-business-search-results></lib-business-search-results>
      }
    </mat-card-content>
  </mat-card>
  }
  <!-- PPSA Search Summary Card -->
  @if (isPpsaSearchOrder() && orderHasSummary()) {
  <app-search-summary></app-search-summary>
  }
  <!-- Business Report Results Card -->
  @if(order.orderTypeID === 'BusinessReport' && order.country != 'US') {
  <lib-business-report-results></lib-business-report-results>
  }
  <!-- Ultimate Beneficial Ownership Report Details Card -->
  @if(uiConfiguration.hasUltimateBeneficialOwnershipReportDetails ?? false) {
  <lib-ubo-order-details-tab-group [uiConfiguration]="uiConfiguration"></lib-ubo-order-details-tab-group>
  }
</div>
}
